var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.roomTypeSet),function(roomTypeMeta){return _c('PodRoomListSwiperView',{key:roomTypeMeta.slug,attrs:{"roomTypeMeta":roomTypeMeta}})}),_c('PodRoomMessageModal')],2)}
var staticRenderFns = []

export { render, staticRenderFns }